import React from 'react';
import { ImportSourceType } from '../../../services/importService';

interface Props { onSelect: (source: number) => void; }

const SOURCES = [
  { type: ImportSourceType.Planner,             label: 'Planner',           color: '#3949AB', desc: 'Import tasks from Microsoft Planner plans' },
  { type: ImportSourceType.ProjectOnline,       label: 'Project Online',    color: '#8E24AA', desc: 'Import from Project Online / PWA — retires September 2026, migrate before then', badge: 'Microsoft retiring Sept 2026', tooltip: 'Microsoft is retiring Project Online in September 2026. Import your projects into Dagrun PM before that date.' },
  { type: ImportSourceType.ProjectProfessional, label: 'Microsoft Project', color: '#00897B', desc: 'Import from .xml export — preserves WBS hierarchy and predecessor dependencies' },
  { type: ImportSourceType.ExcelCSV,            label: 'Excel / CSV',       color: '#43A047', desc: 'Import from spreadsheet files' },
  { type: ImportSourceType.Monday,              label: 'Monday.com',        color: '#F59E0B', desc: 'Import from Monday boards' },
  { type: ImportSourceType.Smartsheet,          label: 'Smartsheet',        color: '#1E88E5', desc: 'Import from Smartsheet sheets' },
  { type: ImportSourceType.Jira,                label: 'Jira Cloud',        color: '#0052CC', desc: 'Import issues from a Jira project' },
  { type: ImportSourceType.Asana,               label: 'Asana',             color: '#F06A6A', desc: 'Import tasks from an Asana project' },
  { type: ImportSourceType.ClickUp,             label: 'ClickUp',           color: '#7B68EE', desc: 'Import tasks from a ClickUp list' },
  { type: ImportSourceType.Trello,              label: 'Trello',            color: '#0079BF', desc: 'Import cards from a Trello board' },
];

export default function SourceSelector({ onSelect }: Props) {
  return (
    <div>
      <h3 style={{ marginBottom: 16 }}>Choose Import Source</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 12 }}>
        {SOURCES.map(s => (
          <div
            key={s.type}
            onClick={() => onSelect(s.type)}
            className="card"
            style={{
              padding: 16,
              cursor: 'pointer',
              position: 'relative',
              transition: 'border-color 0.15s, box-shadow 0.15s',
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--brand)'; e.currentTarget.style.boxShadow = 'var(--shadow-card)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border-light)'; e.currentTarget.style.boxShadow = ''; }}
          >
            <div style={{ width: 40, height: 40, borderRadius: 'var(--r-md)', background: s.color, marginBottom: 8 }} />
            <strong style={{ fontSize: 13, color: 'var(--ink)' }}>{s.label}</strong>
            <p style={{ fontSize: 12, color: 'var(--ink-3)', margin: '6px 0 0', lineHeight: 1.4 }}>{s.desc}</p>
            {s.badge && (
              <span
                className="pill amber"
                title={('tooltip' in s ? (s as { tooltip?: string }).tooltip : undefined) ?? s.badge}
                style={{ position: 'absolute', top: 8, right: 8, fontSize: 10 }}
              >
                {s.badge}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
